import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../hooks/hooks";
import { selectListItems } from "../../../../redux/library/selector";
import { selectEDocsListItems } from "../../../../redux/e-docs/selector";
import { eDocs } from "../../../../redux/e-docs/action";
import PageLoader from "../../../../components/PageLoader";
import Table from "../../../../common/components/table";


const EDocs = () => {
	const dispatch = useAppDispatch()
  const libraryData = useSelector(selectListItems)
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10); 
    const eDocsItems = useSelector(selectEDocsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          {
            field: 'Type', headerName: 'View', sortable: false, filter: false, cellRenderer: 'viewRenderer'
          },
          {
            field: 'Url', headerName: 'Copy Url', sortable: false, filter: false, cellRenderer: 'copyRenderer'
          },
          { field: 'Name', headerName: 'Name', searchField: 'Name', sortable: true, filter: true, filterType: 'text' },
          { field: 'DateCreated', headerName: 'Date Created', isDateValueFormat:true, sortable: true },
          { field: 'DateModified', headerName: 'Date Modified', isDateValueFormat:true, sortable: true }
        ]);
      }
    
  const fetcheDocs=()=>{
    dispatch(eDocs.list({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/e-docs/list`,entity:'eDocs',jsonData:{
  
    "PageNumber": pageData,
    "PageSize": pageSize,
    "SortField": "Id",
    "SortOrder": "desc",
    

    }}))
  }
 
useEffect(() => {
    createColumnDefs()
    fetcheDocs()
}, [pageData,pageSize])

const handleEdit = (data: any) => {
  navigate(`${data?.Id}`)
}
const handleReloadData = () => {
  fetcheDocs()
}
const additionButtons: any = [
 
  
  {
    svg:
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
        <title>Reload this table</title>
        <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>,
    callback: () => handleReloadData(),
  },
];

const handleSearch = (data: any) => {
  let searchCriteria = {};
  if (data?.column) {
    searchCriteria = [{
      FieldName: data?.column,
      FieldText: data?.column,
      FieldType: 'text',
      FilterOperatorId: 6,
      FieldValue: data?.value
    }]
  } else {
    searchCriteria = [{
      FieldName: "Name",
      FieldText: "Name",
      FieldType: 'text',
      FilterOperatorId: 6,
      FieldValue: data?.value
    }]
  } 
  dispatch(eDocs.list({
    url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/e-docs/list`,
    entity:'eDocs',
    jsonData: {
      "PageNumber": pageData,
      "PageSize": pageSize,
      "SortField": "Id",
      "SortOrder": "desc",
      "Searches": searchCriteria,
    }}))
  }

return (
<>
{eDocsItems?.isLoading ?  <PageLoader />: 
<Table columnData={columnDefs} rowData={eDocsItems?.result?.items} setPageData={setPageData} setPageSize={setPageSize} isEdocs
 additionButtons={additionButtons} enableFilter={true} onSearch={handleSearch} paginationData={eDocsItems?.result?.pagination} onEdit={handleEdit} headingName="E Docs"/>
 
}
</> 
);
};

export default EDocs;


